import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { Event } from 'app/shared/typings';
import { AuthContext } from 'app/shared/context/Auth';
import { ActionLink } from 'app/shared/components/atoms';
import { Modal } from 'app/shared/components/molecules';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { GuestShareLink } from 'app/fan/components/organisms/GuestShareLink';

interface Props {
  event?: Event;
  ticketPurchaserName?: string;
  ticketPurchaserEventAttendeeId?: string;
  eventNeighborhoodTitle?: string;
  eventLocalStartsAt?: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const GuestShareLinkModal = ({
  isOpen,
  setIsOpen,
  event,
  ...props
}: Props) => {
  const { user } = useContext(AuthContext);
  const { formatMessage } = useIntl();
  const { eventAttendee } = useEventPageContext();

  if (!event || !user || !eventAttendee || eventAttendee.tickets.length < 2) {
    return null;
  }

  return (
    <Modal
      data-qaid="guest-share-link-modal"
      closeOnOutsideClick={true}
      isFullscreenMobile={false}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={formatMessage({
        id: 'event.attendeeDetailsForm.guestShareLinkInviteHeader',
      })}
      detailText={
        <ActionLink onClick={() => setIsOpen(false)} fontSize="fontSize75">
          {formatMessage({
            id: 'event.attendeeDetailsForm.guestShareLinkAddMyself',
          })}
        </ActionLink>
      }
    >
      <GuestShareLink
        event={event}
        {...props}
        marginTop={0}
        buttonMarginTop={8}
        fullWidthButton={true}
        shareTextShade="dark"
        data-qaid="event-page-guest-share-link-modal"
      />
    </Modal>
  );
};
